export default __webpack_public_path__ + "static/media/disneyplus-flutter.429c3419.JPG";